import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ImportComponentComponent} from "../../shared/import-component/import-component.component";
import {ApiPathsService} from "../../api-paths.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {CampoAggiuntivo} from "../../shared/models/campo-aggiuntivo";
import {HttpClient, HttpEventType} from "@angular/common/http";
import {RmaData} from "../../rma/RmaData";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-import-accessori',
  templateUrl: './import-accessori.component.html',
})
export class ImportAccessoriComponent  {
  @Output() Uploaded = new EventEmitter<any>();
  @Input() campiImport: CampoAggiuntivo[] = [
    {
      modificabile: true,
      nome: 'Excel Danea',
      oggetti: ['fileDanea'],
      multipart:true,
      prevDivClass: 'col-md-12',
      inputType: 'file',
      placeholder: '(xls,xlsx) Size Limit: 5.00 MB',
      visibleifProhibited: true
    },
    {
      modificabile: true,
      nome: 'Immagini zip',
      oggetti: ['fileZip'],
      multipart:true,
      inputType: 'file',
      placeholder: '(zip) Size Limit: 5.00 MB',
      visibleifProhibited: true
    }
  ]
  send = {};
  enableUploadBtn: boolean= true;
   uploadPercent: number;
  constructor(
    private apiPaths: ApiPathsService,
    private modalService : NgbActiveModal,
    private rmaData: RmaData,
    private http: HttpClient,
    private toastService: ToastrService
  ) { }

  uploaded(event){
    this.Uploaded.emit(event);
  }

  closeModal() {
    this.modalService.dismiss();
  }
  importa() {
    const _form: FormData = ApiPathsService.DynamicFormGetter(this.campiImport,this.send);
    var headers = this.rmaData.getRmaMultipartHeaders();
    const restroute = '/prodotti/import/accessori';
    this.http.request('POST', (this.rmaData.getRmaLink() ?? this.apiPaths.getBaseAPI()) + restroute, {
      body: _form,
      reportProgress: true,
      observe: 'events',
      headers: headers,
      params: null,
    })
      .subscribe(
        (event) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.enableUploadBtn = false; // button should be disabled if process uploading
            // const currentDone = event.loaded / event.total;
            this.uploadPercent = Math.round((event.loaded / event.total) * 100);
          } else if (event.type === HttpEventType.Response) {
            if (event.status === 200 || event.status === 201) {
              this.closeModal();
              this.uploaded(event)
            }
            else
              this.handleErrors(event);
          } else {
          }
        },
        (error) => {
          this.handleErrors(error);
        }
      );
  }
  handleErrors(err?) {
    this.enableUploadBtn = true;
    console.log(err)
    if(err){
      let errorMessage = err.error.message || err.statusText;
      if (err.status === 422) {
        errorMessage = "";
        for (const field in err.error) {
          errorMessage += field + " : " + err.error[field] + '\n';
        }
      }
      this.toastService.error(errorMessage, "OOPS!!");
    }
  }

}
